import VendorsPage from "../pages/VendorsPage";
import AddVendor from "../container/vendorList/AddVendor/AddVendor";
import EditVendor from "../container/vendorList/EditVendor/EditVendor";
import ViewVendor from "../container/vendorList/ViewVendor/ViewVendor";

const VendorRoutes = [
  {
    path: "vendor",
    children: [
      { path: "vendors", element: <VendorsPage /> },
      { path: "vendors/create", element: <AddVendor /> },
      { path: "vendors/edit/:id", element: <EditVendor /> }, 
      { path: "vendors/view/:id", element: <ViewVendor /> }, 
    ],
  },
];

export default VendorRoutes;
